import { render } from "./emptySection.vue?vue&type=template&id=06b0da46"
import script from "./emptySection.vue?vue&type=script&lang=js"
export * from "./emptySection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__